<template>
    <div class="fixed-table">
        
    </div>
</template>

<script>
export default {
    name:'fixed-table',
    
}
</script>